(() => {
  // Count visible matches across every page; keep only the first three cards.
  // Both the header and the search page use the same server-side visibility rule.
  window.agSearchResults = async (url, signal) => {
    let nextUrl = new URL(url, window.location.origin);
    let firstDocument;
    let resultsCount = 0;
    const cards = [];
    const visited = new Set();

    while (nextUrl) {
      const key = nextUrl.href;
      if (visited.has(key)) throw new Error('Repeated search count page');
      visited.add(key);
      const response = await fetch(key, { headers: { Accept: 'text/html' }, signal });
      if (!response.ok) throw new Error(`Search count: ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (signal?.aborted) throw new DOMException('Search aborted', 'AbortError');
      const summary = doc.querySelector('[data-search-results-count]');
      const count = Number(summary?.dataset.searchResultsCount);
      if (!summary || !Number.isInteger(count) || count < 0) throw new Error('Missing search count');
      firstDocument ??= doc;
      resultsCount += count;
      const group = doc.querySelector('[data-ag-header-search-groups-template]');
      const pageCards = [...group?.content.querySelectorAll('[data-predictive-search-resource]') || []];
      pageCards.sort((a, b) => Number(a.dataset.predictiveSearchPosition || 0) - Number(b.dataset.predictiveSearchPosition || 0));
      for (const card of pageCards) {
        if (cards.length === 3) break;
        cards.push(card.cloneNode(true));
      }
      // Preserve q/type/view/options even if Shopify's next link omits one.
      const destination = summary.dataset.searchResultsNextUrl;
      if (destination) {
        const candidate = new URL(destination, nextUrl);
        if (candidate.origin !== nextUrl.origin) throw new Error('Invalid search count origin');
        for (const [name, value] of nextUrl.searchParams) {
          if (!candidate.searchParams.has(name)) candidate.searchParams.set(name, value);
        }
        nextUrl = candidate;
      } else nextUrl = null;
    }

    const groups = firstDocument.querySelector('[data-ag-header-search-groups-template]');
    const footer = firstDocument.querySelector('[data-ag-header-search-footer-template]');
    const live = firstDocument.querySelector('[data-ag-header-search-live-region-text]');
    const list = groups?.content.querySelector('ul');
    if (list) {
      const order = ['product', 'article', 'page'];
      cards.sort((a, b) => order.indexOf(a.dataset.predictiveSearchResource) - order.indexOf(b.dataset.predictiveSearchResource));
      cards.forEach((card, index) => { card.id = `predictive-search-option-${card.dataset.predictiveSearchResource}-${index + 1}`; });
      list.replaceChildren(...cards);
    }
    const empty = firstDocument.querySelector('[data-ag-header-search-empty-template]');
    const more = firstDocument.querySelector('[data-ag-header-search-more-template]');
    if (footer && empty && more) {
      const shown = list?.children.length || 0;
      footer.innerHTML = resultsCount === 0 ? empty.innerHTML : resultsCount > shown ? more.innerHTML : '';
      const remaining = footer.content.querySelector('[data-predictive-search-total-count]');
      if (remaining) remaining.textContent = `(${resultsCount - shown})`;
    }
    let liveRegionText = live?.textContent.trim() || '';
    if (live?.hasAttribute('data-many-text')) {
      liveRegionText = resultsCount === 0 ? live.dataset.emptyText : resultsCount === 1 ? live.dataset.oneText : live.dataset.manyText.replaceAll('[count]', String(resultsCount));
    }
    return { resultsCount, groupsMarkup: groups?.innerHTML || '', footerMarkup: footer?.innerHTML || '', liveRegionText };
  };
})();
